import { FormControl, FormLabel } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import Select, {
  ActionMeta,
  GroupBase,
  MultiValue,
  PropsValue
} from 'react-select'
import {
  formElementInterface,
  keyValue,
  keyValueObject,
  keyValuePair,
  selectBoxOptionsInterface
} from '../lib/types'
export const SnapSelect = ({
  onChangeCallBack,
  formElementData,
  styleProps,
  labelProps,
  formattedDataCallBack,
  inputData,
  defaultValues
}: {
  onChangeCallBack: (data: keyValueObject[], name: string) => void
  chakraProps?: keyValue
  styleProps: keyValue
  formElementData: formElementInterface
  labelProps?: keyValue
  formattedDataCallBack: (formattedData: keyValuePair[]) => void
  inputData?: selectBoxOptionsInterface[] | undefined
  defaultValues?: PropsValue<string> | keyValueObject[] | null
}): JSX.Element => {
  const { title, validation, name } = formElementData
  const [selectOptions, setSelectOptions] = useState<
    keyValueObject[] | PropsValue<string> | undefined
  >([])
  const typeCastedInput = inputData as keyValueObject[] | undefined
  useEffect(() => {
    const options = typeCastedInput?.reduce(
      (reducer: keyValueObject[], { id, value, display }) => [
        ...reducer,
        { id, value, label: display }
      ],
      []
    )
    setSelectOptions(options ?? [])
  }, [])

  const handleChange = (
    newValue: MultiValue<string>,
    actionMeta: ActionMeta<string>
  ): void => {
    const getKey = ((): string => {
      switch (formElementData.originalKey) {
        case 'product_instructions':
          return 'product_instruction_list'

        default:
          return 'report_standard_list'
      }
    })()
    const formattedData = newValue.reduce(
      (reducer: keyValueObject[], item) => [
        ...reducer,
        { [getKey]: { id: (item as unknown as keyValue).id } }
      ],
      []
    )
    onChangeCallBack(formattedData, name)
  }

  return (
    <>
      {inputData && (
        <FormControl
          {...styleProps}
          {...(formElementData.holderProps ?? {})}
        >
          <FormLabel {...labelProps}>
            {title} {validation?.required && <sup color="red">*</sup>}
          </FormLabel>

          <Select
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            defaultValue={defaultValues as PropsValue<string>}
            isMulti={true}
            isSearchable={true}
            onChange={handleChange}
            options={
              selectOptions as unknown as ReadonlyArray<
                string | GroupBase<string>
              >
            }
          />
        </FormControl>
      )}
    </>
  )
}
